module.exports = __webpack_public_path__ + "static/media/react1Spread.5ebc6e52.png";